export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.base-data': '基础数据',
  'menu.base-data.project': '项目管理',
  'menu.base-data.building': '楼栋管理',
  'menu.base-data.house': '住宅商铺',
  'menu.base-data.houseDetail': '房屋详情',
  'menu.base-data.parking': '停车位管理',
  'menu.base-data.order-no': '编号配置',
  'menu.base-data.bank-config': '银行配置',
  'menu.base-data.service-config': '服务配置',
  'menu.base-data.service-config-detail': '服务配置详情',
  'menu.document': '文件管理',
  'menu.document.template': '文档模版',
  'menu.document.my-doc': '我的文档',
  'menu.document.instruction': '常用文档',
  'menu.base-data.vehicle': '车辆管理',
  'menu.base-data.bank': '银行管理',
  'menu.property': '房产销售',
  'menu.property.house': '住宅商铺',
  'menu.property.parking': '车位销售',
  'menu.property.sales-overview': '销售总览',
  'menu.property.vehicle': '车辆管理',
  'menu.property.property-agent': '房屋中介',
  'menu.rental': '租聘管理',
  'menu.rental.house': '出租房管理',
  'menu.rental.collection': '出租房收支登记',
  'menu.person': '人员管理',
  'menu.person.houseUser': '房主管理',
  'menu.person.guest': '访客登记',
  'menu.person.decoration': '装修报备',
  'menu.person.moveout': '搬出登记',
  'menu.info': 'APP管理',
  'menu.info.banner': '轮播图',
  'menu.info.announcement': '公告管理',
  'menu.info.Announcement': '系统公告',
  'menu.info.urgent-notice': '紧急通知',
  'menu.info.community': '社区公告',
  'menu.info.hall_rental': '宴会厅出租',
  'menu.info.document': '文档模版',
  'menu.info.contract': '合同文档',
  'menu.info.housekeeper': '专属管家',
  'menu.bill': '收费管理',
  'menu.bill.property-fee': '物业费',
  'menu.bill.water-fee': '水费',
  'menu.bill.electric-fee': '电费',
  'menu.bill.net-fee': '网费',
  'menu.bill.parking-fee': '停车费',
  'menu.bill.other': '其他费用',
  'menu.service': '物业管理',
  'menu.service.property-overview': '物业总览',
  'menu.service.house': '房屋查询',
  'menu.service.service-config': '服务配置',
  'menu.service.open-service': '水电网开通',
  'menu.service.hall-rental': '场地预约',
  'menu.service.msg': '缴费通知',
  'menu.service.review': '物业待审核',
  'menu.service.reviewed': '物业已审核',
  'menu.service.property-review': '物业待审核',
  'menu.service.property-reviewed': '物业已审核',
  'menu.service.vehicle': '车辆绑定',
  'menu.service.maintenance': '报修管理',
  'menu.service.complaint': '投诉管理',

  'menu.sys': '系统管理',
  'menu.sys.user': '用户管理',
  'menu.sys.role': '角色管理',
  'menu.sys.dict': '字典管理',
  'menu.sys.menu': '菜单管理',
  'menu.sys.upload': '文件上传',
  'menu.repair': '报修与投诉',
  'menu.repair.maintenance': '报修管理',
  'menu.repair.complaint': '投诉管理',
  'menu.audit': '审核管理',
  'menu.audit.bill': '物业缴费',
  'menu.audit.property-review': '贷款待审核',
  'menu.audit.finance-review': '财务待审核',
  'menu.audit.finance-reviewed': '财务已审核',
  'menu.pay': '缴费管理',
  'menu.pay.bill': '账单缴费',
  'menu.pay.bill-notice': '缴费通知',
  'menu.pay.msg': '消息管理',
  'menu.notice': '消息管理',
  'menu.notice.msg': '消息管理',
  'menu.notice.daily-report': '每日报表',
  'menu.notice.import-notice': '重要信息',
  'menu.finance': '财务管理',
  'menu.finance.audit-overview': '财务审核',
  'menu.finance.project': '项目管理',
  'menu.finance.bill': '物业缴费',
  'menu.finance.bank': '银行管理',
  'menu.finance.bank-statement': '银行账单',
  'menu.finance.expenses': '财务流水',
  'menu.finance.fin-reporting': '财务申报',
  'menu.finance.pricing_review': '财务核价',
  'menu.finance.budget-request': '预算申请',
  'menu.finance.mortgage-pay': '房贷还款',
  'menu.finance.car-pay': '车位还款',
  'menu.finance.finance-reconciliation': '财务对账',
  'menu.finance.financial-report': '财务报表',
  'menu.finance.daily-report': '对账报表',
  'menu.finance.monthly-report': '每月对账',
  'menu.search': '查询',
  'menu.search.house': '房屋搜索',
  'menu.search.parking': '车位查询',
  'menu.search.search-parking': '车位查询',
  'menu.search.property-reviewed': '还贷查询',
  'menu.search.mortgage-statistics': '房贷统计',
  'menu.search.finance-search': '财务查询',
  'menu.search.user-search': '用户查询',
};
